// Externe Bibliotheken
import React, { Component } from 'react';

// Styles
import './progressBar.scss';

class ProgressBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            percentage: 10,
            t: 200,
            switchtime: 20000,
            text: '',
            isfinished: false,
        };
    }

    componentDidMount() {
        let $this = this;

        this.interval = setInterval(() => {
            $this.move();
        }, this.state.t);

        this.timeout = setTimeout(() => {
            $this.setState(() => ({ isfinished: true }));
        }, this.state.switchtime);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        clearTimeout(this.timeout);
    }

    move() {
        if (this.props.finish === true) {
            this.setState(() => ({ isfinished: true }));
        }

        if (this.state.isfinished === true) {
            let finishText = '';
            if (this.props.finishText !== undefined) {
                finishText = this.props.finishText;
            }

            this.setState(() => ({ text: finishText }));
            this.setState(() => ({ percentage: 100 }));
        }
        if (this.state.percentage === 100) {
            clearInterval(this.interval);
            return;
        }
        this.setState((prevState) => ({ percentage: prevState.percentage + 0.5 }));
    }

    render() {
        return (
            <div>
                <Bar
                    percentage={this.state.percentage}
                    isfinished={this.state.isfinished ? 'finish' : ''}
                    text={this.state.text}
                />
            </div>
        );
    }
}

const Bar = (props) => {
    return (
        <div className={'progress-bar ' + props.isfinished}>
            <Filler percentage={props.percentage} text={props.text} />
        </div>
    );
};

const Filler = (props) => {
    return (
        <div className="filler" style={{ width: `${props.percentage}%` }}>
            <span>{props.text}</span>
        </div>
    );
};

export default ProgressBar;
